import React, { Component } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  UncontrolledDropdown,
} from "reactstrap";
import PropTypes from "prop-types";

import {
  AppHeaderDropdown,
  AppNavbarBrand,
  AppSidebarToggler,
} from "@coreui/react";
import { APP_CONST, getStoredItem, resetStorage } from "../../store/dataStore";
import accounts from "../../api/accounts";
import { handleError } from "@/util/errorHandler";
const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
  state = {
    isOnline: false,
    businessDateTime: "",
    logoImg: "",
    dropdownOpen: false,
  };

  /**
   * Fetch the logo image using a stored participantBankCode
   */
  getLogo = () => {
    let partCode = getStoredItem(APP_CONST.USER_INFO)
      ? JSON.parse(getStoredItem(APP_CONST.USER_INFO)).participantBankCode
        ? JSON.parse(getStoredItem(APP_CONST.USER_INFO)).participantBankCode
        : ""
      : "";
    if (partCode !== "") {
      accounts
        .getLogo(partCode)
        .then(res => {
          this.setState({ logoImg: res.data.logo });
        })
        .catch(handleError);
    } else {
      // participantCode not found
    }
  };

  onDropdownSelected = e => {
    let path = "";
    switch (e.target.id) {
      case "profile":
        path = "/settings/profile";
        break;
      case "changePwd":
        path = "/settings/change_password";
        break;
      case "logout":
        resetStorage();
        path = "/";
        break;
      case "usermanual":
        window.open(
          "https://www.nbc.org.kh/download_files/bakong/Bakong_payment_gateway_user_manual.pdf",
          "_blank",
        );
        return;
      default:
        break;
    }
    this.props.history.push({
      pathname: path,
      state: {
        isFromLoginPage: true,
      },
    });
  };

  renderNavMenu = isCaseReinstallation => {
    return (
      <AppHeaderDropdown direction="down">
        <UncontrolledDropdown>
          <DropdownToggle nav data-cy="nav-menu">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <i className="icon-user icons font-2xl img-avatar nav-dark bg-dark mr-1" />
              <span
                className="h8 nav-dark bg-dark"
                style={{
                  center: "auto",
                }}>
                {getStoredItem(APP_CONST.USERNAME)}
              </span>
            </div>
          </DropdownToggle>
          <DropdownMenu
            right
            style={{
              right: "auto",
            }}>
            {!isCaseReinstallation && (
              <DropdownItem
                id="profile"
                onClick={e => this.onDropdownSelected(e)}
                data-cy="nav-profile">
                <i className="fa fa-user" />
                Profile
              </DropdownItem>
            )}
            {!isCaseReinstallation && (
              <DropdownItem
                id="changePwd"
                onClick={e => this.onDropdownSelected(e)}
                data-cy="nav-change-password">
                <i className="icon-lock" />
                Change Password
              </DropdownItem>
            )}
            <DropdownItem
              id="usermanual"
              onClick={e => this.onDropdownSelected(e)}
              data-cy="nav-user-manual">
              <i className="fa fa-book" />
              User manual
            </DropdownItem>
            <DropdownItem
              id="logout"
              onClick={e => this.onDropdownSelected(e)}
              data-cy="nav-logout">
              <i className="fa fa-lock" />
              Logout
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </AppHeaderDropdown>
    );
  };

  // START ReactJS app life cycle
  componentDidMount() {
    // dl logo
    this.getLogo();
  }
  // END ReactJS app life cycle

  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand>
          {/* h4 navbar-dark bg-dark : custom style to make it look fit with nav bar dark theme */}
          <span className="h5 navbar-dark bg-dark mt-2">Payment Gateway</span>
        </AppNavbarBrand>
        <AppSidebarToggler
          className="d-md-down-none navbar-dark bg-dark"
          display="lg"
        />

        <Nav className="d-md-down-none navbar-dark bg-dark" navbar>
          <NavItem className="px-3">
            {this.state.logoImg && (
              <img
                src={`data:image/png;base64, ${this.state.logoImg}`}
                className="img-responsive"
                alt=""
              />
            )}
          </NavItem>
          <NavItem>
            <span>
              {getStoredItem(APP_CONST.USER_INFO)
                ? JSON.parse(getStoredItem(APP_CONST.USER_INFO))
                    .participantBankName
                  ? JSON.parse(getStoredItem(APP_CONST.USER_INFO))
                      .participantBankName
                  : ""
                : ""}
            </span>
          </NavItem>
        </Nav>

        <Nav className="navbar navbar-dark bg-dark ml-auto" navbar>
          <NavItem className="px-3" />
          {this.renderNavMenu(
            getStoredItem(APP_CONST.CURRENT_ACTION) ===
              APP_CONST.ACTION_REINSTALL,
          )}
        </Nav>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
